import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Story } from './components/Story';
import { Result } from './components/Result';
import { Product } from './components/Product';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Closing } from './components/Closing';
import { CtaButton } from './components/ui';
import { UpsellProvider } from './components/UpsellContext';
import { UpsellModal } from './components/UpsellModal';
export function App() {
  return <UpsellProvider data-id="element-0">
      <div className="min-h-screen bg-brand-cream font-sans text-brand-dark selection:bg-brand-violet selection:text-white overflow-x-hidden" data-id="element-1">
        <main className="pb-28 md:pb-0" data-id="element-2">
          <Hero data-id="element-3" />
          <Problem data-id="element-4" />
          <Story data-id="element-5" />
          <Result data-id="element-6" />
          <Product data-id="element-7" />
          <WhatYouGet data-id="element-8" />
          <Bonuses data-id="element-9" />
          <Offer data-id="element-10" />
          <Guarantee data-id="element-11" />
          <Testimonials data-id="element-12" />
          <Faq data-id="element-13" />
          <Closing data-id="element-14" />
        </main>

        {/* Mobile Sticky CTA */}
        <div className="fixed bottom-0 left-0 right-0 p-3 bg-white/95 backdrop-blur-md border-t border-gray-200 z-50 md:hidden shadow-[0_-10px_20px_rgba(0,0,0,0.08)]" data-id="element-15">
          <CtaButton className="w-full shadow-xl" data-id="element-16" />
        </div>

        {/* Upsell modal — opens whenever any CTA button is clicked */}
        <UpsellModal data-id="element-17" />
      </div>
    </UpsellProvider>;
}